import { InfoCircle } from "@untitled-ui/icons-react";
import { Typography } from "@kirvanobr/typography";
import { InfoProps } from "./Info.types";

export function Info({ children }: InfoProps) {
  return (
    <div className="bg-foreground-100 px-4 py-3 flex items-center gap-4">
      <InfoCircle fontSize={20} className="text-primary shrink-0" />
      <Typography variant="body" size="t4" weight="regular">
        {children}
      </Typography>
    </div>
  );
}
